import React, { useEffect, useRef } from "react";
import { Box, CircularProgress, Typography, makeStyles } from "@material-ui/core";
import ChatMessage from "./ChatMessage";

const useStyles = makeStyles((theme) => ({
  list: {
    height: 320,
    overflowY: "auto",
    padding: theme.spacing(1, 1.5),
    backgroundColor: "#fafafa",
  },
  empty: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.secondary,
  },
}));

export default function ChatMessageList({ messages, loading, currentEmail }) {
  const classes = useStyles();
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, [messages.length, loading]);

  if (loading) {
    return (
      <Box className={`${classes.list} ${classes.empty}`}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (!messages || messages.length === 0) {
    return (
      <Box className={`${classes.list} ${classes.empty}`}>
        <Typography variant="body2">No messages yet.</Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.list} ref={ref}>
      {messages.map((m, i) => (
        <ChatMessage
          key={`${m.chatTimeStamp}-${i}`}
          msg={m}
          mine={
            currentEmail &&
            m.chatSenderEmail &&
            currentEmail.toLowerCase() === m.chatSenderEmail.toLowerCase()
          }
        />
      ))}
    </Box>
  );
}
